<template>
  <v-card
    flat
    class="pa-5 pt-0 bg-pwt_snow"
    v-if="unreadNotifications.length > 0 || pastNotifications.length > 0"
  >
    <!-- profile section -->
    <ProfileCard />
    <!--  unread notifications bar -->
    <div id="unread_notifications_bar">
      <v-icon color="#2eaeff" class="mr-2"> mdi-bell-badge-outline </v-icon>
      <span>
        {{ unreadNotifications.length }} unread notification{{
          unreadNotifications.length !== 1 ? 's' : ''
        }}
      </span>
    </div>
    <!-- notifications section -->
    <v-card-title class="text-h5"> Notifications </v-card-title>
    <!-- search bar -->
    <v-card-text>
      <v-text-field
        v-model="search"
        label="Search all notifications..."
        single-line
        hide-details
        bg-color="transparent"
      >
        <template v-slot:append-inner>
          <!-- <NotificationsFilter :notifications="allNotifications" /> -->
          <!-- <FilterBtn>
            Filter
            <template v-slot:dialog>
              <v-card>
                <v-card-title>Filter notifications</v-card-title>
                <v-card-text>
                  <v-checkbox label="Unread" />
                  <v-checkbox label="Past" />
                </v-card-text>
              </v-card>
            </template>
          </FilterBtn> -->
        </template>
      </v-text-field>
    </v-card-text>
    <v-card-title class="text-h6"> Unread notifications </v-card-title>
    <v-card-text>
      <v-list v-if="unreadNotifications.length > 0" class="mb-5">
        <NotificationsListItem
          v-for="notification in unreadNotifications"
          :key="notification.notification_id"
          :notification="notification"
        />
      </v-list>

      <div v-else class="text-subtitle-1 mb-5">No unread notifications</div>
    </v-card-text>
    <v-card-title class="text-h6"> Past notifications </v-card-title>
    <v-card-text>
      <v-list v-if="pastNotifications.length > 0" class="mb-5">
        <NotificationsListItem
          v-for="notification in pastNotifications"
          :key="notification.notification_id"
          :notification="notification"
        />
      </v-list>

      <div v-else class="text-subtitle-1 mb-5">No past notifications</div>
    </v-card-text>
  </v-card>
  <!-- full empty state -->
  <v-card v-else flat class="pa-5 pt-0 bg-pwt_snow">
    <v-card-title class="text-center"> Nothing here yet </v-card-title>
    <v-card-text class="text-center">
      You don’t have any activity yet. Start planning trips or managing your account to see your
      notifications and activity
    </v-card-text>
  </v-card>
</template>
<script setup lang="ts">
import ProfileCard from '@/components/user/profile/ProfileCard.vue'
import { computed, ref } from 'vue'
import NotificationsListItem from './NotificationsListItem.vue'
import type { Notification } from './notifications.types'

const testData: Notification[] = [
  {
    category: 'VEHICLE',
    user_id: '3802ab1f-b773-a924-fcf7-0c65ba77695b',
    notification_id: 'c1410bf5-908b-43ec-9355-57983ff6c95c',
    read_status: 'UNREAD',
    title: "New vehicle 'ABC123'",
    message: "A new vehicle 'ABC123' has been added to your fleet.",
    date: 'string',
    linked_vehicle: "fake-vehicle-id-123",
  },
  {
    user_id: '6073005e-f269-081f-b73a-97df9eece03a',
    notification_id: 'b3682a00-5e90-f711-31ad-9137595574a9',
    read_status: 'READ',
    title: 'George assigned a trip to you',
    message: 'George assigned you a trip to ‘187 High Street North, Carterton 5713’.',
    date: 'string',
    linked_trip: '4fda0546-dc1d-f371-ee59-886c8117f108',
    trip_name: 'string',
    trip_date: 'string',
    category: 'TRIP',
  },
]

const search = ref('')

const allNotifications = ref<Notification[]>(testData)
const unreadNotifications = computed<Notification[]>(() =>
  allNotifications.value.filter((n) => n.read_status === 'UNREAD'),
)
const pastNotifications = computed<Notification[]>(() =>
  allNotifications.value.filter((n) => n.read_status === 'READ'),
)
</script>
<style scoped>
#unread_notifications_bar {
  background-color: #eaf7ff;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  height: 70px;
  margin-bottom: 20px;
  margin-top: 20px;
}
</style>
